
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQb0dj_458Mmy7JARxH3CMW2afkhXEZ4wwKLioHUqkF_T8Meta } from "/opt/build/repo/nuxt/pages/index.vue?macro=true";
import { default as searchR0Pn9Q_45bld_5o2CW8Avjz9MQwwIUHic3IxR13tEHocUMeta } from "/opt/build/repo/nuxt/pages/search.vue?macro=true";
import { default as downloadJXB3ZcoDkS6SjIA32tUSVtjZIkXoOgpBHY7fvGb4vwwMeta } from "/opt/build/repo/nuxt/pages/download.vue?macro=true";
import { default as _91slug_93mqakfIopMAoaqQQRs3X82238FgwnMPg8fQ4ZFD6jRgkMeta } from "/opt/build/repo/nuxt/pages/page/[slug].vue?macro=true";
import { default as _91slug_936WxQQo8_45zX1lYxcd5oyeFfFJPGtxafEQTRfSaRCQE0sMeta } from "/opt/build/repo/nuxt/pages/site/[slug].vue?macro=true";
import { default as index3uMcDSjS5Ny9mluCuWsV0i8XAtEd2pCGi9hAWC_45gGBgMeta } from "/opt/build/repo/nuxt/pages/brands/index.vue?macro=true";
import { default as previewX0oq272WfOGJ39xPWbvl2H5bh8kQ18VT8jmKMx3i0c0Meta } from "/opt/build/repo/nuxt/pages/page/preview.vue?macro=true";
import { default as _91slug_93VBtpvqJxPuez_r2TChCsaZiCZ4hf4EgWD1Hykg93Tf4Meta } from "/opt/build/repo/nuxt/pages/types/[slug].vue?macro=true";
import { default as _91slug_93y5SC7eSEJ_qHhvrMF4xMxuvLATC_6LaYZAsTcDbXZPcMeta } from "/opt/build/repo/nuxt/pages/brands/[slug].vue?macro=true";
import { default as _91slug_93Y2qOKza_xP76VOXdgERvQI9JFxi7PeS6kBb39SB6aAgMeta } from "/opt/build/repo/nuxt/pages/cities/[slug].vue?macro=true";
import { default as indexKRPpc8EhUTGUfkDYKio7pDH1QyydDhmgpkaG6hYIlsUMeta } from "/opt/build/repo/nuxt/pages/content/index.vue?macro=true";
import { default as _91slug_93VSEBPvs4_FNG_fytAUyHyE_nh1RBnri30pC839a3n_EMeta } from "/opt/build/repo/nuxt/pages/careers/[slug].vue?macro=true";
import { default as resources0C4XJG_45eQIcj4Nk2iTVSnYADw_45CbxBTMwLwrOOniKDMMeta } from "/opt/build/repo/nuxt/pages/page/resources.vue?macro=true";
import { default as previewKoQIsyFq_ncC_sE9hMSMJx94ofWEyW86Jq0XoBqlvoEMeta } from "/opt/build/repo/nuxt/pages/content/preview.vue?macro=true";
import { default as _91slug_93HH0eJIGksvmg_XYLt09R90PMUD26vXOrpjV_45QydPxckMeta } from "/opt/build/repo/nuxt/pages/countries/[slug].vue?macro=true";
import { default as _91slug_93FaBTicrTPyicrP6C_Sdg0f9hko6_45D8DzGBfF9DiN1HIMeta } from "/opt/build/repo/nuxt/pages/industries/[slug].vue?macro=true";
import { default as confirmedjJ6Qk7FZWkO2Z1900t9w5UebmR_45jCmoaQWBWZ_45l3SfQMeta } from "/opt/build/repo/nuxt/pages/newsletter/confirmed.vue?macro=true";
import { default as _91slug_9388EOTDL0yUd5TWnozyLvgeT68GIoLkic4WaJMUzMdUYMeta } from "/opt/build/repo/nuxt/pages/opportunities/[slug].vue?macro=true";
import { default as previewv8dE4KxaNagbP1C9PEgHlYPafoZIXbaEDC3olVINE0MMeta } from "/opt/build/repo/nuxt/pages/opportunities/preview.vue?macro=true";
import { default as index7DzHR2S82372FMl_GLHmzYS2dYLs1RjFOTjhUtUCPjMMeta } from "/opt/build/repo/nuxt/pages/content/[section]/index.vue?macro=true";
import { default as _91slug_93WsnRN0xj0fQ4hDIXnu5_45Brhu23Xc3_47bDgVDR4iBM8Meta } from "/opt/build/repo/nuxt/pages/content/[section]/[slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/nuxt/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: searchR0Pn9Q_45bld_5o2CW8Avjz9MQwwIUHic3IxR13tEHocUMeta || {},
    component: () => import("/opt/build/repo/nuxt/pages/search.vue")
  },
  {
    name: "download",
    path: "/download",
    component: () => import("/opt/build/repo/nuxt/pages/download.vue")
  },
  {
    name: "page-slug",
    path: "/page/:slug()",
    component: () => import("/opt/build/repo/nuxt/pages/page/[slug].vue")
  },
  {
    name: "site-slug",
    path: "/site/:slug()",
    component: () => import("/opt/build/repo/nuxt/pages/site/[slug].vue")
  },
  {
    name: "brands",
    path: "/brands",
    component: () => import("/opt/build/repo/nuxt/pages/brands/index.vue")
  },
  {
    name: "page-preview",
    path: "/page/preview",
    meta: { ...(previewX0oq272WfOGJ39xPWbvl2H5bh8kQ18VT8jmKMx3i0c0Meta || {}), ...{"middleware":["preview"]} },
    component: () => import("/opt/build/repo/nuxt/pages/page/preview.vue")
  },
  {
    name: "types-slug",
    path: "/types/:slug()",
    component: () => import("/opt/build/repo/nuxt/pages/types/[slug].vue")
  },
  {
    name: "brands-slug",
    path: "/brands/:slug()",
    component: () => import("/opt/build/repo/nuxt/pages/brands/[slug].vue")
  },
  {
    name: "cities-slug",
    path: "/cities/:slug()",
    component: () => import("/opt/build/repo/nuxt/pages/cities/[slug].vue")
  },
  {
    name: "content",
    path: "/content",
    component: () => import("/opt/build/repo/nuxt/pages/content/index.vue")
  },
  {
    name: "careers-slug",
    path: "/careers/:slug()",
    component: () => import("/opt/build/repo/nuxt/pages/careers/[slug].vue")
  },
  {
    name: "page-resources",
    path: "/page/resources",
    component: () => import("/opt/build/repo/nuxt/pages/page/resources.vue")
  },
  {
    name: "content-preview",
    path: "/content/preview",
    meta: { ...(previewKoQIsyFq_ncC_sE9hMSMJx94ofWEyW86Jq0XoBqlvoEMeta || {}), ...{"middleware":["preview"]} },
    component: () => import("/opt/build/repo/nuxt/pages/content/preview.vue")
  },
  {
    name: "countries-slug",
    path: "/countries/:slug()",
    component: () => import("/opt/build/repo/nuxt/pages/countries/[slug].vue")
  },
  {
    name: "industries-slug",
    path: "/industries/:slug()",
    component: () => import("/opt/build/repo/nuxt/pages/industries/[slug].vue")
  },
  {
    name: "newsletter-confirmed",
    path: "/newsletter/confirmed",
    component: () => import("/opt/build/repo/nuxt/pages/newsletter/confirmed.vue")
  },
  {
    name: "opportunities-slug",
    path: "/opportunities/:slug()",
    component: () => import("/opt/build/repo/nuxt/pages/opportunities/[slug].vue")
  },
  {
    name: "opportunities-preview",
    path: "/opportunities/preview",
    meta: { ...(previewv8dE4KxaNagbP1C9PEgHlYPafoZIXbaEDC3olVINE0MMeta || {}), ...{"middleware":["preview"]} },
    component: () => import("/opt/build/repo/nuxt/pages/opportunities/preview.vue")
  },
  {
    name: "content-section",
    path: "/content/:section()",
    component: () => import("/opt/build/repo/nuxt/pages/content/[section]/index.vue")
  },
  {
    name: "content-section-slug",
    path: "/content/:section()/:slug()",
    component: () => import("/opt/build/repo/nuxt/pages/content/[section]/[slug].vue")
  }
]